import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { IconButton, Tooltip } from '@mui/material';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { AppContext } from '../../../../../RoutesWithAuth';
import axios from '../../../../common/AxiosConfig';



const useStyles = makeStyles(() => ({
    tableWrapper: {
        marginTop: '2px',
        width: '100%',
        overflowX: 'auto',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
            height: '10px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#a8a8a8',
            borderRadius: '4px',
            '&:hover': {
                background: '#888'
            },
        },
        '& table': {
            width: '100%',
            minWidth: '760px',
            tableLayout: 'fixed',
            borderCollapse: 'separate'
        },
        '& thead': {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: '#C4D2E2',
        },
        '& th': {
            padding: '3px 16px',
            //textAlign: 'center',
            color: '#202124',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid #c8cbce',
            letterSpacing: '0.3px',
            whiteSpace: 'nowrap',
            background: '#C4D2E2',
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .documentColumnName': {
            width: '30%',
        },
        '& tbody td.documentColumnName': {
            //color: '#3fb93f'
        },
        '& .narrowColumn': {
            width: '15%'
        },
        '& .viewDocumentColumn': {
            width: '10%',
            padding: '2px 4px',
            textAlign: 'center'
        },
        '& tbody tr': {
            height: '4vh',
            background: '#f7fafd',
            fontWeight: 600,
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            //background: '#dee2e6',
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '2px 16px',
            textAlign: 'left',
            color: '#334155',
            fontSize: '0.85rem',
            fontWeight: 600,
            borderRight: '1px solid #edf2f7',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
}));


const COLUMNS = [
    { key: 'document_name', label: 'Document Name', className: 'documentColumnName' },
    { key: 'uploaded_date', label: 'Uploaded Date', className: 'narrowColumn' },
    { key: 'uploaded_by', label: 'Uploaded By', className: 'narrowColumn' },
    { key: 'view_url', label: 'View Document', className: 'viewDocumentColumn' },
];

const DocumentsTable = ({ taskId }) => {
    const classes = useStyles();
    const context = useContext(AppContext);
    const authToken = context.authToken.get;
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let isActive = true;
        setError('');
        setIsLoading(false);
        if (!taskId) return;

        setRows([]);
        setIsLoading(true);
        axios.get(`centra/privacy-task/${encodeURIComponent(taskId)}/documents`, {
            headers: { Authorization: authToken }
        }).then((response) => {
            if (isActive) setRows(response.data?.documents || []);
        }).catch((err) => {
            if (isActive) {
                setError(err?.response?.data?.message || err?.message || 'Unable to load documents.');
            }
        }).finally(() => {
            if (isActive) setIsLoading(false);
        });

        return () => {
            isActive = false;
        };
    }, [taskId, authToken]);

    const renderCell = (row, column) => {
        if (column.key === 'view_url') {
            return row.view_url ? (
                <Tooltip title="View Document">
                    <IconButton
                        size="small"
                        aria-label={`View ${row.document_name}`}
                        onClick={() => window.open(row.view_url, '_blank', 'noopener,noreferrer')}
                    >
                        <FindInPageIcon fontSize="medium" />
                    </IconButton>
                </Tooltip>
            ) : null;
        }
        return row[column.key];
    };

    return (
        <div>
            {error && <p role="alert">{error}</p>}
            {isLoading && <p role="status">Loading documents...</p>}
            <div className={`tableWrapper ${classes.tableWrapper}`}>
                <table>
                    <thead>
                        <tr>
                            {COLUMNS.map((column) => <th className={column.className} key={column.key}>{column.label}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={row.id ?? rowIndex}>
                                {COLUMNS.map((column) => (
                                    <td className={column.className} key={column.key}>{renderCell(row, column)}</td>
                                ))}
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={COLUMNS.length}></td>
                        </tr>
                        <tr>
                            <td colSpan={COLUMNS.length}></td>
                        </tr>
                        {!isLoading && !error && rows.length === 0 && (
                            <tr><td colSpan={COLUMNS.length}>No documents found.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DocumentsTable;